import { Routes, Route } from 'react-router-dom';
import Layout from "../components/Layout/layout";

import Home from '../pages/Home';
import OurDoctors from '../pages/OurDoctors';
import Services from '../pages/Services';
import AboutClinic from '../pages/AboutClinic';
import Programs from '../pages/Programs';
import ProgramDetailPage from '../pages/ProgramDetailPage';
import BookAppointment from '../pages/BookAppointment';
import SymptomChecker from '../pages/SymptomChecker';
// renders without Layout
import SignUp from '../pages/SignUp';
import SignIn from '../pages/SignIn';
import Thankyou from '../pages/Thankyou-screen';
import Userinfo from '../pages/Userinfo';
import Symptoms from '../pages/Symptoms';
import Conditions from '../pages/Conditions';
import Resources from '../pages/Resources';
import ConditionDetails from '../pages/ConditionDetails';
import CareJourney from '../pages/CareJourney';
import PatientExperience from '../pages/PatientExperience';
import LifeStages from '../pages/LifeStages';
// import MenopauseAssessment from '../pages/MenopauseAssessment';
import MenoPauseResults from '../pages/MenoPauseResults';
import PatientOnboardingFlow from '../pages/PatientOnboardingFlow';
import HealthAssessments from '../pages/HealthAssessments';
// import SummaryScreen from '../components/HealthChatBot/screens/SummaryScreen';
import ViewResults from '../components/HealthAssessment/ViewSummary';
import CareNavigator from '../pages/CareNavigator';
import Findtherightprogram from '../pages/findprogram';
import BookingFlow from '../pages/BookingFlow';

import DigitalWomensHealthLifeStages from '../pages/DigitalWomensHealthLifeStages';
import PcosRiskCheck from '../pages/PCOSRiskScreen';
import WomenHealthRecord from '../pages/WomenHealthRecord';
import WomensHealth from '../components/WomenHealthRecord/WomensHealth';
import LifeStage from '../components/WomenHealthRecord/LifeStage';
import Overview from '../components/WomenHealthRecord/Overview';
import ClinicalHistory from '../components/WomenHealthRecord/ClinicalHistory';
import PregnancyRiskScreening from '../pages/PregnancyRiskScreening';
// import MentalWellnessScreening from '../pages/MentalWellnessScreening';
import MentalWellnessScreening from '../components/RiskScreening/MentalWellnessScreening';
import MenopauseRiskScreening from '../components/RiskScreening/MenopauseRiskScreening';
import PCOSRiskScreening from '../components/RiskScreening/PCOSRiskScreening';
import PregnancyRiskScreening2 from '../components/RiskScreening/PregRiskScreening';
// import { FindCare } from '../pages/FindCare';
import FindCare from '../pages/FindCare'
import { ClinicScheduleProvider } from '../context/ClinicScheduleContext';

// Helper wrapper — renders children inside Layout 
function WithLayout({ children }) {
  return <Layout>{children}</Layout>;
}

const AppRoutes = () => {
  return (
     <ClinicScheduleProvider>
    <Routes>
      <Route path="/" element={<WithLayout><Home /></WithLayout>} />
      <Route path="/our-doctors" element={<WithLayout><OurDoctors /></WithLayout>} />
      <Route path='/services' element={<WithLayout><Services /></WithLayout>} />
      <Route path='/about' element={<WithLayout><AboutClinic /></WithLayout>} />
      <Route path='/programs' element={<WithLayout><Programs /></WithLayout>} />
      <Route path='/programs/:slug' element={<WithLayout><ProgramDetailPage /></WithLayout>} />
      <Route path='/book-appointment' element={<WithLayout><BookAppointment /></WithLayout>} />
      <Route path='/findCare' element={<FindCare/>}/>
      <Route path='/book-an-appointment' element={<BookingFlow />} />
      {/* <Route path='/symptoms' element={<Symptoms />} /> */}
      <Route path='/conditions' element={<WithLayout><Conditions/></WithLayout>} />
      <Route path='/conditions/:slug' element={<WithLayout><ConditionDetails/></WithLayout>} />
      <Route path='/resource' element={<WithLayout><Resources/></WithLayout>}/>
      <Route path='/carejourney' element={<CareJourney/>}/>
      <Route path='/lifeStages' element={<WithLayout><LifeStages/></WithLayout>}/>
      <Route path='/patientExperience' element={<WithLayout><PatientExperience/></WithLayout>}/>
      <Route path='/symptom-checker' element={<Symptoms />} />
      <Route path='/user-info' element={<PatientOnboardingFlow />} />
      {/* <Route path='/health-assessment' element={<WithLayout><HealthAssessment /></WithLayout>} /> */}
      {/* <Route path='/health-assessment' element={<HealthAssessment />} /> */}
      <Route path='/userinfo' element={<Userinfo/>} />
      <Route path='/MenoPauseResults' element={<MenoPauseResults/>} />
      <Route path='/health-assessment' element={<HealthAssessments/>}/>
      <Route path='/care-navigator' element={<CareNavigator/>}/>
      <Route path='/findprogram' element={<Findtherightprogram/>}/>
      <Route path='/digitalWLifeStages' element={<DigitalWomensHealthLifeStages/>}/>
      <Route path='/women-health-record' element={<WomenHealthRecord/>}/>
      <Route path='/clinical-history' element={<ClinicalHistory/>}/>
      <Route path='/overview' element={<Overview/>}/>
      <Route path='/lifestage' element={<LifeStage/>}/>
      <Route path='/wellness-screening' element={<MentalWellnessScreening/>}/>
      <Route path='/menopause-screening' element={<MenopauseRiskScreening/>}/>
      <Route path='/pcos-screening' element={<PCOSRiskScreening/>}/>
      <Route path='/pregnancy-screening' element={<PregnancyRiskScreening2/>}/>
      <Route
        path="/:assessmentType"
        element={<HealthAssessments />}
      />
      {/* <Route path='/view-results' element={<ViewResults/> } /> */}
      <Route path='/pcos-risk-screening'element={<PcosRiskCheck/>} />
      <Route path='/preg-risk-screening' element={<PregnancyRiskScreening/>}/>
      {/* Routes WITHOUT layout */}
      <Route path='/register' element={<SignUp />} />
      <Route path='/sign-in' element={<SignIn />} />
      <Route path="/Thankyou-screen" element ={<WithLayout><Thankyou/></WithLayout>} />
    </Routes>
    </ClinicScheduleProvider>
  ); 
};

export default AppRoutes;